<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-primary pb-8 pt-5 pt-md-8 hide">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <!-- COMPONENTE PRINCIPAL -->
          <div class="row">
            <div class="col-lg-3">
              <div class="card shadow">
                <div class="card-header">
                  <i class="fas fa-bars"></i> Menus
                </div>
                <div class="card-body p-0">
                  <div class="list-group small">
                    <a
                      v-for="(item, menuIndex) of menus"
                      :key="menuIndex"
                      href="javascript:void(0);"
                      class="list-group-item list-group-item-action border-0"
                      @click="selectMenu(item)"
                    >
                      {{item.caption}}
                      <i class="fa fa-chevron-right float-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="card shadow">
                <div class="card-header">
                  <i class="fas fa-info-circle"></i> Detalles
                </div>
                <div class="card-body">
                  <div class="form-group">
                    <input
                      v-model="selectedMenu.caption"
                      type="text"
                      placeholder="Nombre del Menu"
                      name
                      id
                      class="form-control form-control-alternative"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      v-model="selectedMenu.name"
                      type="text"
                      name
                      id
                      placeholder="Logic Vue Route Name"
                      class="form-control form-control-alternative"
                    />
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-control-alternative custom-checkbox mb-3">
                      <input
                        class="custom-control-input"
                        id="customCheck5"
                        type="checkbox"
                        v-model="selectedMenu.activo"
                      />
                      <label class="custom-control-label" for="customCheck5">Activo</label>
                    </div>
                  </div>

                  <div class="form-group">
                    <button class="btn btn-info btn-sm" type="button">Actualizar</button>
                    <button class="btn btn-secondary btn-sm" type="button">
                      <i class="fas fa-bars"></i> Ver Menus
                    </button>
                  </div>
                  <p class="text-muted small m-0">
                    Modificado por
                    <span class="text-info">{{selectedMenu.usuario_actualizacion}}</span>,
                    <br />en 02/08/2019
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="card shadow">
                <div class="card-header">
                  <i class="fas fa-bars"></i> Submenus
                </div>
                <div class="card-body p-0">
                  <ul class="list-group list-group-flush small">
                    <div class="list-group p-2">
                      <div class="form-group mb-1">
                        <input
                          :disabled="loading"
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="Nombre del Menu"
                        />
                      </div>
                      <div class="form-group mb-2">
                        <input
                          :disabled="loading"
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="Logic Vue Route Name"
                        />
                      </div>
                      <div class="form-group text-right">
                        <button
                          class="btn btn-secondary btn-sm"
                          type="button"
                          :disabled="loading"
                        >Cancelar</button>
                        <button class="btn btn-success btn-sm" type="button" :disabled="loading">
                          Agregar
                          <i class="fa fa-plus-circle"></i>
                        </button>
                      </div>
                    </div>
                    <li
                      class="list-group-item border-0 text-center"
                      v-if=" selectedMenu.submenus == null || selectedMenu.submenus.length == 0"
                    >No hay submenus asignados</li>
                    <li
                      class="list-group-item border-0"
                      v-for="(submenu, indexSubmenu) of selectedMenu.submenus"
                      :key="indexSubmenu"
                    >
                      <span class>{{submenu.caption_submenu}}</span>
                      <button
                        v-b-tooltip.hover
                        title="Agregar al departamento"
                        type="button"
                        class="btn btn-secondary btn-sm float-right"
                      >
                        <i class="far fa-square"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Menu } from "@/views/ti/departamentos/models/menu.model";
import mockup from "@/views/ti/departamentos/mockup";
export default {
  name: "Menus",
  data() {
    return {
      loading: false,
      controller: {
        title: "Menus",
        mainRouter: "/tinformacion/departamentos/menus"
      },
      menus: mockup.menus(),
      selectedMenu: new Menu()
    };
  },
  methods: {
    selectMenu(item) {
      //let index = this.menus.indexOf(item);
      this.selectedMenu = item;
      console.log(this.selectedMenu);
    }
  }
};
</script>
